module.exports = __webpack_public_path__ + "static/media/title.48258ac3.png";